/**
 * wordpress/status Vuex Module
 */

/**
 * Store state for wordpress/status module
 */
const state = {
  isThemesLoaded: false,
  isSettingsLoaded: false
}

/**
 * Action for wordpress/status module
 */
const actions = {
}

/**
 * Mutations for wordpress/status module
 */
const mutations = {
  themesLoaded: (state, payload) => {
    state.isThemesLoaded = true
  },
  settingsLoaded: (state, payload) => {
    state.isSettingsLoaded = true
  }
}

/**
 * Getters for wordpress/status module
 */
const getters = {
  isThemesLoaded: state => state.isThemesLoaded,
  isSettingsLoaded: state => state.isSettingsLoaded
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/status.js